// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vuvhL","col":"styles_col__275cR"};